// export const BASE_URL = "http://localhost/coinmarketcap/";
export const BASE_URL = "https://backend-crypto.itoma.co.uk";